import { Flex, Icon, Input } from '@chakra-ui/react';
import { RiSearchLine } from 'react-icons/ri';
import { search } from 'ss-search';

import { ClienteDTO } from '../../../dtos/ClienteDTO';

type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};

interface DTSearchParams {
	clientes: ClienteDTO[];
	setPesqClientes: (cliente: ClienteDTO[]) => void;
	controls: ControlsData;
	setControls: (control: ControlsData) => void;
	handleUpdateList: (
		page: number,
		perPage: number,
		clientes: ClienteDTO[],
	) => void;
};

const DTSearch: React.FC<DTSearchParams> = ({
	clientes,
	setPesqClientes,
	controls,
	setControls,
	handleUpdateList,
}) => {

	function handlePesquisa(event: string) {
		const texto = event;

		if (texto === '' || texto === ' ') {
			setPesqClientes(clientes);

			setControls({
				...controls,
				page: 1,
				totalPage: Math.ceil(clientes.length / controls.perPage),
			});

			handleUpdateList(1, controls.perPage, clientes);
			return;
		};

		const searchKeys = ['nome', 'doc', 'phone', 'cid'];
		const results = search(clientes, searchKeys, texto) as ClienteDTO[];

		setPesqClientes(results);
		setControls({
			...controls,
			page: 1,
			totalPage: Math.ceil(results.length / controls.perPage),
		});

		handleUpdateList(1, controls.perPage, results);
	};

	return (
		<Flex as="form" ml={["0", "0", "4"]} mb={2}>
			<Flex
				as="label"
				flex="1"
				py="2"
				pl="2"
				pr="6"
				maxWidth={400}
				alignSelf="center"
				color="gray.900"
				position="relative"
				bg="gray.50"
				borderRadius="full"
			>
				<Input
					color="gray.900"
					variant="unstyled"
					px="4"
					mr="4"
					placeholder="Pesquisar"
					_placeholder={{ color: 'gray.400' }}
					onChange={e => handlePesquisa(e.target.value)}
				/>

				<Icon as={RiSearchLine} fontSize="20" color="blue.500" />
			</Flex>
		</Flex>
	);
};

export default DTSearch;